module.exports = __webpack_public_path__ + "static/media/39-2.5ceb87fa.mp3";